module.exports = __webpack_public_path__ + "6019d8ee793ce36dc4552f6f47400b0b.MP3";